// src/context/TourContext.js
import React, { createContext, useContext, useState } from 'react';

const TourContext = createContext(undefined);

export function TourProvider({ children }) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const startTour = () => {
    setRun(true);
    setStepIndex(0);
  };

  const value = {
    run,
    stepIndex,
    setStepIndex,
    startTour,
    setRun,
  };

  return (
    <TourContext.Provider value={value}>
      {children}
    </TourContext.Provider>
  );
}

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error("useTour must be used within TourProvider");
  }
  return context;
};